import { Container, Stack } from '@mui/material';
import React from 'react';

import { Page } from '../../../../components';
import HeaderBreadcrumbs from '../../../../components/header-breadcrumbs';
import RiskAssessmentSearchAndHistory from "./search-and-history";

export const RiskAssessment: React.FC = () => {

    const [title, setTitle] = React.useState<string>('Assessment Search & History');

    return (
        <Page title="Assessment Search & History">
            <Container maxWidth={false}>
                {/* The search view renders its own hero header (title === ''). */}
                {title && (
                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <HeaderBreadcrumbs
                            heading={title}
                            links={[
                                {
                                    name: '',
                                    href: '/risk-assessment'
                                },
                            ]}
                            activeLast={false}
                        />
                    </Stack>
                )}
                <RiskAssessmentSearchAndHistory setTitle={setTitle}/>
            </Container>
        </Page>
    )
}